import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';

export default {
  getOpenShipmentOrders({ commit }, payload = {}) {
    const {
      start,
      end,
      warehousesIds,
    } = payload;

    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query (
      $start_date: Date!
      $end_date: Date!
      $warehouse_ids: [Int]
    ) {
      orderOpenDelayedOccurrence(
        start_date: $start_date,
        end_date: $end_date,
        warehouse_ids: $warehouse_ids
      ) {
        total delayed delayed_lp delayed_with_ocurrence
      }
    }`,
      {
        start_date: Moment(start).format('YYYY-MM-DD'),
        end_date: Moment(end).format('YYYY-MM-DD'),
        warehouse_ids: warehousesIds,
      })
      .then((res) => {
        const { data = {} } = res || {};
        const { orderOpenDelayedOccurrence = {} } = data || {};

        commit('setOpenShipmentOrders', orderOpenDelayedOccurrence);
        commit('toggleLoading', false);
      }).catch(() => {
        commit('toggleLoading', false);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-open-shipment/store/actions.js